export function nowInSeconds() {
  return new Date().getTime() / 1000;
}
